<template>
  <div
    class="border rounded-lg w-full h-full flex flex-col bg-white overflow-auto"
    v-loading="loading"
  >
    <div
      class="h-12 bg-tm-blue text-white w-full rounded-t-lg flex items-center px-4"
    >
      <h5 class="text-base font-bold">Sensor List</h5>
    </div>
    <div v-if="content">
      <div class="px-4 pb-8 mt-2 flex flex-col w-full">
        <SimpleTable
          :headers="getHeaders()"
          :items="sensorData"
          :customizationPage="customizationPage"
          :options="options"
          :selectedIds="form.customerSensorIds"
          @selection-changed="onSelectionChanged"
          @next-step="nextPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/dx/SimpleTable'
// import { dataDummy as dummy } from './dataDummy'
export default {
  components: {
    SimpleTable
  },
  props: {
    content: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean
    },
    sensorData: {
      type: Array
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      viewData: [],
      viewDataDialog: false,
      editForm: [],
      editFormDialog: false,
      actionTable: false,
      selectedTable: [],
      selectedIds: [],
      customizationPage: '',
      options: {
        allowToRefetch: true,
        allowToNextStep: false,
        allowMultipleSelect: true,
        autoWidth: true
      }
    }
  },
  methods: {
    showData(val) {
      this.$router.push({
        name: 'TenantSensor',
        params: { id: `${val.DceDeviceId}` }
      })
      this.viewData = val
      // console.log({ val })
    },
    editRow(val) {
      this.editFormDialog = !this.editFormDialog
      this.viewData = val
      // console.log({ val })
    },
    onSelectionChanged(selectedRowsData) {
      if (selectedRowsData.length == 0) {
        this.options.allowToNextStep = false
      } else {
        this.options.allowToNextStep = true
      }
      this.selectedTable = selectedRowsData

      var dceSensorIds = this.selectedTable.map((x) => x.DceSensorId)
      this.$emit('sensorsSelected', dceSensorIds)
    },
    nextPage() {
      this.$emit(
        'nextPage',
        this.selectedTable.map((x) => x.DceSensorId)
      )
    },
    getHeaders() {
      return [
        {
          type: 'string',
          text: 'Name',
          value: 'SensorName'
        },
        {
          type: 'string',
          text: 'Type',
          value: 'SensorType'
        },
        {
          type: 'string',
          text: 'Server Code',
          value: 'ServerCode'
        },
        {
          type: 'string',
          text: 'DCE Location',
          value: 'DceLocation'
        },
        {
          type: 'string',
          text: 'Device DCE Name',
          value: 'DeviceDceName'
        },
        {
          type: 'string',
          text: 'Device Type',
          value: 'TypeDevice'
        },
        {
          type: 'string',
          text: 'Value',
          value: 'AverageVal'
        }
      ]
    }
  }
}
</script>

<style>
.row-custom {
  grid-template-rows: 40px 200px 300px repeat(3, 1fr) 20px;
}

.selection-custom {
  background-color: transparent !important;
  color: #1a202c !important;
  border: none !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
